import React, { useState, useEffect } from 'react';
import { getAllAuthors } from 'services/profissionals';
import Author from 'services/profissionals/models/author-interface';
import ProfissionalCarousel from 'components/ProfissionalCarousel';
import { profissionalSettings } from 'config/settingsSlider';
import { SectionContainer } from 'components/Container';

import {
  ProfissionalsWrapper,
  TitleWrapper,
  Flag,
  MainBtn,
  ButtonWrapper,
} from './style';

import Diamond from 'assets/icon/icone-diamante.svg';
import Seta from 'assets/icon/seta.svg';

const Medics: React.FC = () => {
  const [profissionals, setProfissionals] = useState<Array<Author>>([]);

  useEffect(() => {
    (async () => {

      const token = 'Bearer ' + process.env.REACT_APP_UNLOGGED_TOKEN;
      
      const localMedics = await getAllAuthors(
        { is_active: true },
        { Authorization: token },
      );

      setProfissionals(localMedics.authors);
    })();
  }, []);

  return (
    <ProfissionalsWrapper>
      <SectionContainer>
        <TitleWrapper>
          <Flag>
            <img src={Diamond} alt="Icone diamante" /> Profissionais
            especializados
          </Flag>
          <h2>Conheça nossa equipe</h2>
          <p>
            Profissionais altamente qualificados e experientes, dedicados ao
            cuidado integral da gestante e do bebê.
          </p>
        </TitleWrapper>
        <ProfissionalCarousel
          profissionals={profissionals}
          sliderSettings={profissionalSettings}
        />
        <ButtonWrapper>
          <MainBtn href="#">
            Inscreva-se Agora <img src={Seta} alt="Arrow" />
          </MainBtn>
          <span>100% online e gratuito</span>
        </ButtonWrapper>
      </SectionContainer>
    </ProfissionalsWrapper>
  );
};

export default Medics;
